import { render, staticRenderFns } from "./roomStructureList.vue?vue&type=template&id=23c2ee8b&scoped=true"
import script from "./roomStructureList.vue?vue&type=script&lang=js"
export * from "./roomStructureList.vue?vue&type=script&lang=js"
import style0 from "./roomStructureList.vue?vue&type=style&index=0&id=23c2ee8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2ee8b",
  null
  
)

export default component.exports